import actions from './actions';

const logout = () => dispatch => {
  window.authManager.logout();
  dispatch(actions.logout);
};

const login = () => dispatch => {
  window.authManager
    .login()
    .then(
      response => dispatch(actions.loadAuthSuccess(response)),
      error => dispatch(actions.loadAuthFail(error))
    );
};

const checkAuth = () => dispatch => {
  window.authManager
    .checkLogin()
    .then(
      response => dispatch(actions.loadAuthSuccess(response)),
      error => dispatch(actions.loadAuthFail(error))
    );
};

export default {
  logout,
  login,
  checkAuth
};



// WEBPACK FOOTER //
// ./src/redux/auth/operations.js